import { Button, dialog, InputFactory } from "nq-component";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { createNotification } from "../../../../../createNotification";
import BaseFormPresenter from "../../../../../components/common/BaseFormPresenter";
import { CreditsDeduction } from "../../../../../components/common/Converter";

function addWithoutPayDateRange(obj) {
  const startDate = new Date(obj.startdate);
  const endDate = new Date(obj.enddate);

  // Flatten dateRange to get all selected dates
  const selectedDates = new Set();
  obj.dateRange.forEach((group) => {
    group.forEach((range) => {
      const [start, end] = range;
      const current = new Date(start);
      const rangeEnd = new Date(end);

      while (current <= rangeEnd) {
        selectedDates.add(current.toISOString().split("T")[0]);
        current.setDate(current.getDate() + 1);
      }
    });
  });

  // Find dates not in dateRange
  const unselectedDates = [];
  const current = new Date(startDate);

  while (current <= endDate) {
    const dateStr = current.toISOString().split("T")[0];
    if (!selectedDates.has(dateStr)) {
      unselectedDates.push(dateStr);
    }
    current.setDate(current.getDate() + 1);
  }

  // Format as dateRange structure (consecutive dates grouped)
  const withoutPayDateRange = [];
  let i = 0;

  while (i < unselectedDates.length) {
    const rangeStart = unselectedDates[i];
    let rangeEnd = rangeStart;

    // Find consecutive dates
    while (i + 1 < unselectedDates.length) {
      const current = new Date(unselectedDates[i]);
      const next = new Date(unselectedDates[i + 1]);
      const diff = (next - current) / (1000 * 60 * 60 * 24);

      if (diff === 1) {
        rangeEnd = unselectedDates[i + 1];
        i++;
      } else {
        break;
      }
    }

    withoutPayDateRange.push([[rangeStart, rangeEnd]]);
    i++;
  }

  return {
    ...obj,
    withoutPayDateRange,
  };
}

class LeaveApproverFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  getDurationFormula(startdate, enddate) {
    const startDate = new Date(startdate);
    const endDate = new Date(enddate);

    // Calculate the difference in milliseconds
    const differenceInMs = endDate - startDate + 1;

    if (differenceInMs) {
      // Convert milliseconds to days
      const differenceInDays =
        Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1;

      return `${differenceInDays} Day/s`;
    } else {
      return "";
    }
  }

  DialogConfirmation(status) {
    this.view
      .showConfirmDialog("Click Confirm to continue!", "Confirm", "Confirm")
      .then(() => {
        dialog.close();
        this.submitData(status);
      })
      .catch(() => {});
  }

  async submitData(status) {
    this.view.showProgressDialog();
    const { stats, acl, category, employee, leaveType, duration, ...rest } =
      this.view.state.object;
    const approveDuration = this.getDurationFormula(
      this.view.state.object.startdate,
      this.view.state.object.enddate,
    );

    const data = {
      categoryType: status,
      stats: "For HRMS Processing",
      selectedType: leaveType.name,
      id: this.view.getObjectId(),
      duration: approveDuration,
      ...(employee && { employee: { id: employee.id } }),
      ...(leaveType && { leaveType: { id: leaveType.id } }),
    };

    if (status === "Without Pay") {
      await upsertUseCase().execute("leave_request", data);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "Your Leave Request has been approved!";
      const NOTIFICATION_RECEIVER = [data?.createdBy?.id || data?.employee?.id];
      const NOTIFICATION_REDIRECT = "lmanagement";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );

      dialog.close();
      this.showSuccess("Approved!");
      return;
    }

    const withoutPayDateRange = addWithoutPayDateRange(rest);
    const submitData = {
      ...data,
      ...withoutPayDateRange,
    };

    const allAvailableCredit = await findObjectUseCase().execute("leave_cred", {
      where: {
        empID: submitData.employee.id,
      },
    });

    const currentCredits = allAvailableCredit.filter(
      (item) => item.type === leaveType.name,
    );

    console.log("currentCredits: ", currentCredits);
    if (!currentCredits[0]?.current || currentCredits.length === 0) {
      dialog.close();
      this.showError("No credits available.");
      return;
    }
    const creditDeduct = parseFloat(submitData.creditDeduction);

    const hasVacationLeave = allAvailableCredit.some(
      (item) => item.type === "Vacation Leave",
    );

    // include without pat date
    // withoutPayDateRange

    if (leaveType.name === "Sick Leave" && hasVacationLeave) {
      this.handleSickLeaveWithVacationDeduct(
        submitData,
        creditDeduct,
        allAvailableCredit,
        status,
      );
      return;
    }
    if (leaveType.name === "Wellness Leave") {
      this.handleWellnessLeave(
        submitData,
        creditDeduct,
        allAvailableCredit,
        status,
      );
      return;
    }

    // if (leaveType.name === "Forced/Mandatory Leave") {
    //   if (hasVacationLeave) {
    //     this.handleForcedLeave(
    //       submitData,
    //       creditDeduct,
    //       allAvailableCredit,
    //       status,
    //     );
    //   } else {
    //     dialog.close();
    //     this.showError(
    //       "Your vacation leave credits have already been exhausted. Please file a leave without pay (LWOP) if you wish to proceed with your leave request.",
    //     );
    //     return;
    //   }
    //   return;
    // }

    if (leaveType.name === "Compensatory Time-Off") {
      this.CTOOvertimerequestDeduction(
        creditDeduct,
        currentCredits,
        submitData,
      );
      return;
    }

    const totalCurrentCred = currentCredits?.reduce((total, item) => {
      return total + parseFloat(item.current);
    }, 0);

    // console.log("Credi: ", creditDeduct);
    // console.log("TOTAL: ", totalCurrentCred);
    // return;
    if (currentCredits.length > 0 && creditDeduct <= totalCurrentCred) {
      const leaveCred = parseFloat(currentCredits[0].current) - creditDeduct;
      currentCredits[0].current = leaveCred.toFixed(3);
      // handle Leave Card
      // this.GenerateLeaveCard(creditDeduct, currentCredits[0], submitData);
      await upsertUseCase().execute("leave_cred", currentCredits[0]);
      await upsertUseCase().execute("leave_request", submitData);

      //  CREATE NOTIFICATION
      const NOTIFICATION_MESSAGE = "Your Leave Request has been approved!";
      const NOTIFICATION_RECEIVER = [submitData.createdBy.id];
      const NOTIFICATION_REDIRECT = "lmanagement";

      createNotification(
        NOTIFICATION_MESSAGE,
        NOTIFICATION_RECEIVER,
        NOTIFICATION_REDIRECT,
      );
      dialog.close();
      // if (status !== "With Pay") {
      //   dialog.close();
      // }
      this.showSuccess("Successfully Approved");
      return;
    } else {
      dialog.close();
      this.showError("Insufficient Credits");
      if (status !== "With Pay") {
        dialog.close();
      }
    }
  }

  async CTOOvertimerequestDeduction(creditDeduct, currentCredits, submitData) {
    if (currentCredits.length === 0) {
      dialog.close();
      this.showError("Insufficient Credits");
      return;
    }
    const ctoCredit = currentCredits[0];
    // currentCredits.find(
    //   (item) => item.type === "Compensatory Time Off"
    // );

    console.log("CURRENT: ", ctoCredit);
    if (
      parseFloat(ctoCredit.current) >= creditDeduct &&
      currentCredits.length > 0
    ) {
      const current = parseFloat(ctoCredit.current) - creditDeduct;
      ctoCredit.current = current.toFixed(3);
      // this.GenerateLeaveCard(creditDeduct, ctoCredit, submitData);
      await upsertUseCase().execute("leave_request", submitData);
      await upsertUseCase().execute("leave_cred", ctoCredit);
      dialog.close();
      this.showSuccess("Successfully Approved");
    } else {
      dialog.close();
      this.showError("Insufficient Credits");
    }
  }

  // async handleForcedLeave(
  //   submitData,
  //   creditDeduct,
  //   allAvailableCredit,
  //   status,
  // ) {
  //   const vacationLeave = allAvailableCredit.find(
  //     (item) => item.type === "Vacation Leave",
  //   );
  //   const forcedLeave = allAvailableCredit.find(
  //     (item) => item.type === "Forced/Mandatory Leave",
  //   );

  //   const creditsVacation = parseFloat(vacationLeave.current) - creditDeduct;
  //   const creditsForced = parseFloat(
  //     Math.max(forcedLeave.current - creditDeduct, 0),
  //   );

  //   if (creditsVacation < 0) {
  //     dialog.close();
  //     this.showError(
  //       "Your vacation leave credits have already been exhausted. Please file a leave without pay (LWOP) if you wish to proceed with your leave request.",
  //     );
  //     return;
  //   }

  //   vacationLeave.current = creditsVacation.toFixed(3);
  //   forcedLeave.current = creditsForced.toFixed(3);

  //   try {
  //     await upsertUseCase().execute("leave_cred", vacationLeave);
  //     await upsertUseCase().execute("leave_cred", forcedLeave);
  //     await upsertUseCase().execute("leave_request", submitData);
  //     dialog.close();
  //     this.showSuccess("Successfully Approved");
  //     return;
  //   } catch (e) {
  //     dialog.close();
  //     console.error("Error: ", e);
  //   }
  // }

  async handleSickLeaveWithVacationDeduct(
    submitData,
    creditDeduct,
    allAvailableCredit,
    status,
  ) {
    // const credit = CreditsDeduction(allAvailableCredit, 0, 0, creditDeduct);

    const sickLeave = allAvailableCredit.find(
      (item) => item.type === "Sick Leave",
    );
    const vacationLeave = allAvailableCredit.find(
      (item) => item.type === "Vacation Leave",
    );
    if (
      parseFloat(sickLeave?.current || 0) +
        parseFloat(vacationLeave?.current || 0) <
      creditDeduct
    ) {
      dialog.close();
      this.showError("Insufficient Credits");
      return;
    }

    sickLeave.current = parseFloat(sickLeave?.current || 0) - creditDeduct;
    let remainingDeduction = 0;

    if (sickLeave.current < 0) {
      remainingDeduction = Math.abs(sickLeave.current);

      sickLeave.current = 0;

      const vacationDeduction =
        parseFloat(vacationLeave?.current || 0) - remainingDeduction;
      vacationLeave.current = vacationDeduction.toFixed(3);

      this.GenerateLeaveCard(remainingDeduction, vacationLeave, submitData);
      submitData.vacationLeaveDeduction = remainingDeduction.toFixed(3);
    }

    // console.log("SICK: ", sickLeave);
    // return;

    sickLeave.current = Number(sickLeave.current).toFixed(3);
    let sickDeduction = creditDeduct;
    if (remainingDeduction > 0) {
      sickDeduction = creditDeduct - remainingDeduction;
    }

    try {
      this.GenerateLeaveCard(sickDeduction, sickLeave, submitData);
      await upsertUseCase().execute("leave_cred", sickLeave);
      await upsertUseCase().execute("leave_cred", vacationLeave);
      await upsertUseCase().execute("leave_request", submitData);
      dialog.close();
      this.showSuccess("Successfully Approved");
      return;
    } catch (e) {
      dialog.close();
      console.error(e.message || e);
    }

    // return

    // const vacationLeave = credit.updatedCredits.find(
    //   (item) => item.type === "Vacation Leave",
    // );
    // if (parseFloat(vacationLeave.current) < 0) {
    //   this.showError("Insufficient Credits");
    //   return;
    // }

    // console.log('TEST: ', credit)
    // return

    // submitData.vacationLeaveDeduction = credit.vacationLeaveDeduction;
    // credit.updatedCredits.forEach(async (item) => {
    //   // handle Leave Card
    //   this.GenerateLeaveCard(creditDeduct, item, submitData);

    //   await upsertUseCase().execute("leave_cred", item);
    // });
    // try {
    //   await upsertUseCase().execute("leave_request", submitData);
    //   dialog.close();
    //   this.showSuccess("Successfully Approved");
    //   return;
    // } catch (e) {
    //   dialog.close();
    //   console.error(e.message || e);
    // }
  }

  async handleWellnessLeave(
    submitData,
    creditDeduct,
    allAvailableCredit,
    status,
  ) {
    const wellnessLeave = allAvailableCredit.find(
      (item) => item.type === "Wellness Leave",
    );
    const vacationLeave = allAvailableCredit.find(
      (item) => item.type === "Vacation Leave",
    );
    if (
      parseFloat(wellnessLeave?.current || 0) +
        parseFloat(vacationLeave?.current || 0) <
      creditDeduct
    ) {
      dialog.close();
      this.showError("Insufficient Credits");
      return;
    }

    wellnessLeave.current =
      parseFloat(wellnessLeave?.current || 0) - creditDeduct;

    if (wellnessLeave.current < 0) {
      const remainingDeduction = Math.abs(wellnessLeave.current);

      wellnessLeave.current = 0;

      const vacationDeduction =
        parseFloat(vacationLeave?.current || 0) - remainingDeduction;
      vacationLeave.current = vacationDeduction.toFixed(3);

      this.GenerateLeaveCard(remainingDeduction, vacationLeave, submitData);
      submitData.vacationLeaveDeduction = remainingDeduction.toFixed(3);
    }

    wellnessLeave.current = Number(wellnessLeave.current).toFixed(3);
    vacationLeave.current = Number(vacationLeave.current).toFixed(3);

    try {
      // this.GenerateLeaveCard(creditDeduct, wellnessLeave, submitData);
      await upsertUseCase().execute("leave_cred", wellnessLeave);
      await upsertUseCase().execute("leave_cred", vacationLeave);
      await upsertUseCase().execute("leave_request", submitData);
      dialog.close();
      this.showSuccess("Successfully Approved");
      return;
    } catch (e) {
      dialog.close();
      console.error(e.message || e);
    }
  }

  async GenerateLeaveCard(creditDeduct, findLeaveType, submitData) {
    const generateLeaveCard = {
      employee: { id: findLeaveType.empID },
      leaveType: findLeaveType.type,
      withPay: creditDeduct.toFixed(3),
      balance: findLeaveType.current,
      startDate: submitData.startdate,
      endDate: submitData.enddate,
      categoryType: submitData.categoryType,
    };
    try {
      await upsertUseCase().execute("leave_card", generateLeaveCard);
    } catch (e) {
      console.error("E: ", e);
    }
  }

  async handleForCompliance() {
    let complianceRemarks = "";
    const { object } = this.view.state;
    dialog.fire({
      html: (
        <>
          <div className="p-2">
            <h4>For Compliance</h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                dialog.close();
                this.view.showProgressDialog();
                this.confirmCompliance(object, complianceRemarks);
              }}
            >
              <label>
                Remarks<span className="text-danger">*</span>
              </label>
              <InputFactory
                type="String"
                _type="Text"
                required
                onChange={(value) => {
                  complianceRemarks = value;
                }}
              />
              <hr />
              <div className="mt-4 mb-4 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light fs-sm me-3"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  // onClick={this.handleSaveButton.bind(this)}
                  className="btn btn-primary fs-sm me-3"
                >
                  confirm
                </button>
              </div>
            </form>
          </div>
        </>
      ),
      footer: false,
    });
  }

  async confirmCompliance(object, complianceRemarks) {
    try {
      await upsertUseCase().execute("leave_request", {
        id: object.id,
        stats: "For Compliance",
        complianceRemarks,
      });
      dialog.close();
      this.showSuccess("Leave request marked as For Compliance");
    } catch (e) {
      dialog.close();
      console.error("Error: ", e.message || e);
    }
  }
}

export default LeaveApproverFormPresenter;
